import { Injectable } from '@angular/core';
import { MobileState } from './mobile-state';

@Injectable()
export class MobileStateCreator {

  create(allData: any): MobileState {
    return {
        isMobile: false,
        userEmail: allData.account.userEmail,
        continueTo: allData.feature.InstallationV2.step
    };
  }
}
